/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import { faMapMarkerAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import styles from '../App.module.css';

const LoadFavouriteModal = ({
    container,
    layerUrl,
    favourites,
    isOpen,
    onCancel,
    onFeaturesSelect,
    onSelectorSelect,
    onRemove
}: {
    container: string;
    layerUrl: string;
    favourites: any;
    isOpen: boolean;
    onCancel: Function;
    onFeaturesSelect: Function;
    onSelectorSelect: Function;
    onRemove: Function;
}) => {
    const cancel = () => {
        if (onCancel !== undefined) onCancel();
    };
    const selectFeatures = (favourite: any) => {
        if (onFeaturesSelect !== undefined) onFeaturesSelect(favourite.ids);
    };
    const selectSelector = (favourite: any) => {
        if (onSelectorSelect !== undefined) onSelectorSelect(favourite);
    };
    const remove = (id: string) => {
        if (onRemove !== undefined) onRemove(id);
    };

    // Remove saved features that dont apply to report layer.
    let layerFavourites: any = {};
    if (favourites !== undefined) {
        layerFavourites = { ...favourites };
        for (const [key] of Object.entries(layerFavourites)) {
            if (
                layerFavourites[key].layer?.url !== undefined &&
                layerFavourites[key].layer?.url !== layerUrl
            )
                delete layerFavourites[key];
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={cancel} container={container}>
            <ModalHeader toggle={cancel}>Load...</ModalHeader>
            <ModalBody>
                {Object.keys(layerFavourites).length > 0 ? (
                    <div className={styles.list}>
                        {Object.keys(layerFavourites).map((key: string) => {
                            const f = layerFavourites[key];
                            return (
                                <div className={styles.favouriteItem} key={key}>
                                    <button
                                        className={`${styles.btn} ${styles.label}`}
                                        title="Load"
                                        aria-label="Load"
                                        onClick={() => {
                                            if (f.tool !== undefined)
                                                selectSelector(f);
                                            else selectFeatures(f);
                                        }}
                                    >
                                        {f.tool === 'polyline' && (
                                            <span className="esri-icon-polyline"></span>
                                        )}
                                        {f.tool === 'polygon' && (
                                            <span className="esri-icon-polygon"></span>
                                        )}
                                        {f.tool === 'rectangle' && (
                                            <span className="esri-icon-checkbox-unchecked"></span>
                                        )}
                                        {f.tool === 'circle' && (
                                            <span className="esri-icon-radio-unchecked"></span>
                                        )}
                                        {f.tool === undefined && (
                                            <span>
                                                <FontAwesomeIcon
                                                    icon={faMapMarkerAlt}
                                                />
                                            </span>
                                        )}
                                        <span>{f.label}</span>
                                    </button>
                                    <button
                                        className={styles.btn}
                                        title="Remove"
                                        aria-label="Remove"
                                        onClick={() => remove(key)}
                                    >
                                        <span>
                                            <FontAwesomeIcon
                                                icon={faTrashAlt}
                                            />
                                        </span>
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div>You haven't saved anything yet.</div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={cancel}>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default LoadFavouriteModal;
